<template>
  
</template>

<script>
export default {

}
</script>

<style>

</style>
<script>
import { resetPin } from "@/api/card";
export default {
  computed: {
    device() {
      return this.$store.state.app.device;
    },
    username(){
      return this.$store.state.user.fullname;
    }
  },
  data(){
    return {
      cardID: ""
    }
  },
  methods:{

    openDialog(cardID){
      this.cardID = cardID;
      this.$confirm('This will Reset PIN. Continue?', 'Confirm', {
          confirmButtonText: 'RESET PIN',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          this.submitResetPin();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Reset PIN canceled'
          });          
        });
    },

    submitResetPin(){
      let data = {
        "user": this.username,
        "terminalLocation": "GB"
      }
       resetPin(this.cardID, data).then(({result}) =>{
        if(result){
          this.$notify({
            title: 'Success',
            message: `Reset PIN successfully`,
            type: 'success',
            duration: 2000
          });
          
        }
      })
    },
    handleClose(){
    }
  }
}
</script>

<style>

</style>